import moment from "moment";
import { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import PaymentMoreDropdown from "../../Components/Form/Dropdowns/PaymentMoreDropdown";
import SmallButton from "../../Components/Form/Buttons/SmallButton";
import { ImageCell } from "./PaymentTableCells";
import { levelOptions } from "./dummies";

// brands table data
export const PaymentsCols = [
  { label: "InvoiceNo", field: "invoiceNo" },
  { label: "date", field: "date" },
  { label: "fee", field: "fee" },
  { label: "Semester", field: "semester" },
  { label: "Action", field: "action" },
];

const SuccessfulPaymentActions = ({ payment, accessToken }: { payment: any; accessToken?: string }) => {
  const [loading, setLoading] = useState(false);

  const handleReTrigger = async () => {
    setLoading(true);
    try {
      const token = accessToken || JSON.parse(localStorage.getItem("currentStudent") || "{}")?.accessToken;
      const res = await axios.get(
        `https://api.report.erp.gouni.edu.ng/api/Payments/ResendPaymentNotification`,
        {
          params: { invoiceNumber: payment?.invoiceNumber },
          headers: {
            accept: "*/*",
            ...(token && { Authorization: `Bearer ${token}` })
          }
        }
      );
      const msg = typeof res.data === "string" ? res.data : (res.data?.message || "Notification re-triggered successfully!");
      toast.success(msg);
    } catch (err: any) {
      const errMsg = err?.response?.data?.message || err?.response?.data || err?.message || "Failed to re-trigger receipt notification.";
      toast.error(errMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
      <SmallButton
        handleClick={() => window.location.href = `https://verify.gouni.edu.ng/api/auth/sso?accessToken=${accessToken}&target=receipts`}
        buttonText="Download Receipt"
        textTransform="capitalize"
        customStyle={{ fontSize: '12px', height: '30px', padding: '5px 15px' }}
      />
      <SmallButton
        handleClick={handleReTrigger}
        buttonText="re-trigger reciept"
        textTransform="capitalize"
        loading={loading}
        customStyle={{ fontSize: '12px', height: '30px', padding: '5px 15px' }}
      />
      {payment?.feeScheduleId === 34 && (
        <SmallButton
          handleClick={() => {
            const token = accessToken || JSON.parse(localStorage.getItem("currentStudent") || "{}")?.accessToken || "";
            window.location.href = `https://verify.gouni.edu.ng/api/auth/sso?accessToken=${token}&target=tellers&uploadfeeid=${payment?.paymentId}`;
          }}
          buttonText="re-upload offline fee"
          textTransform="capitalize"
          customStyle={{ fontSize: '12px', height: '30px', padding: '5px 15px' }}
        />
      )}
      <PaymentMoreDropdown paymentId={payment?.paymentId} />
    </div>
  );
};

export const paymentRows = (data: any, type?: string, accessToken?: string) => {
  const res = data?.map((payment: any) => {
    return {
      name: (
        <ImageCell
          avatar="/assets/images/SVG/user-1.svg"
          firstName={payment?.firstName}
          lastName={payment?.lastName}
          // userName="@hillary"
        />
      ),
      invoiceNo: <span>{payment?.invoiceNumber}</span>,
      semester: (
        <span>
          {payment?.semesterId === 1
            ? "First Semester"
            : payment?.semesterId === 2
            ? "Second Semester"
            : "N/A"}
        </span>
      ),
      gateway: <span>{payment?.paymentMeans}</span>,
      date: (
        <span>{moment(payment?.transactionDate).format("Do MMM YYYY")}</span>
      ),
      fee: <span>{payment?.feeSchedule?.feeScheduleName}</span>,
      receipt: (
        <span style={{ width: `150px` }}>{payment?.tellerNoOrReceiptId}</span>
      ),
      faculty: <span>{payment?.facultyName}</span>,
      amount: <span>₦ {payment?.amount}</span>,
      department: <span>{payment?.departmentName}</span>,
      action: type !== "UnSuccessful" ? (
        <SuccessfulPaymentActions payment={payment} accessToken={accessToken} />
      ) : (
        <SmallButton
          handleClick={() => window.location.href = `https://verify.gouni.edu.ng/api/auth/sso?accessToken=${accessToken}&target=receipts`}
          buttonText="Confirm payment?"
          textTransform="capitalize"
          customStyle={{ fontSize: '12px', height: '30px', padding: '5px 15px' }}
        />
      ),
    };
  });

  return res;
};

export const feeMappingCols = [
  { label: "Fee Schedule", field: "feeSchedule" },
  { label: "Pay By Installment", field: "payInstallment" },
  { label: "Department", field: "department" },
  { label: "Level", field: "level" },
  { label: "Session", field: "session" },
  { label: "Semester", field: "semester" },
  { label: "Gender", field: "gender" },
];

export const feeMappingRows = (
  data: any,
  feeSchedule: any,
  department: any,
  sessions: any,
  semesters: any
) => {
  const res = data?.map((payment: any) => {
    return {
      feeSchedule: (
        <span>
          {
            feeSchedule?.filter(
              (x: any) => x?.value === payment?.feeScheduleId
            )[0]?.label
          }
        </span>
      ),
      payInstallment: (
        <span>{payment?.paymentInstallmentId === 1 ? "True" : "False"}</span>
      ),
      level: (
        <span>
          {
            levelOptions?.filter((x: any) => x?.value === payment?.levelId)[0]
              ?.label
          }
        </span>
      ),
      session: (
        <span>
          {
            sessions?.filter((x: any) => x?.value === payment?.sessionId)[0]
              ?.label
          }
        </span>
      ),
      receipt: (
        <span style={{ width: `150px` }}>{payment?.tellerNoOrReceiptId}</span>
      ),
      semester: (
        <span>
          {
            semesters?.filter((x: any) => x?.value === payment?.semesterId)[0]
              ?.label
          }
        </span>
      ),
      gender: <span>{payment?.genderId === 1 ? "Male" : "Female"}</span>,
      department: (
        <span>
          {department?.filter((x: any) => x?.value === payment?.departmentId)[0]
            ?.label || "N/A"}
        </span>
      ),
      action: <PaymentMoreDropdown paymentId={payment?.paymentId} />,
    };
  });

  return res;
};
